import { ArrayClassConverterFactory, ClassConverterFactory } from "src/app/core/services/mapper/data-property.converter";
import { ManquementContenantEdition } from "./manquement-contenant-edition.model";
import { ManquementSiteEdition } from "./manquement-site-edition.model";

export class ManquementMouvementEdition {
    static jsonMap = {
        millesime: { key: 'millesime', optional: true, default: '' },
        cahier: { key: 'cahier', optional: true, default: '' },
        produit: { key: 'produit', optional: true, default: '' },
        produitOrigine: { key: 'produitOrigine', optional: true, default: '' },
        numeroLot: { key: 'numeroLot', optional: true, default: '' },
        cepage: { key: 'cepage', optional: true, default: '' },
        volume: { key: 'volume', optional: true, default: '' },
        type: { key: 'type', optional: true, default: '' },
        logement: { key: 'logement', optional: true, default: '' },
        contenantList: { key: 'contenant', optional: true, default: '' },
        date: { key: 'date', optional: true, default: '' },
        dateRetiraison: { key: 'dateRetiraison', optional: true, default: '' },
        typeConditionnement: { key: 'typeConditionnement', optional: true, default: '' },
        degre: { key: 'degre', optional: true, default: '' },
        numeroDossier: { key: 'numeroDossier', optional: true, default: '' },
        commentaire: { key: 'commentaire', optional: true, default: '' },
        procedure: { key: 'procedure', optional: true, default: '' },
        couleur: { key: 'couleur', optional: true, default: '' },
        numeroEchantillon: { key: 'numeroEchantillon', optional: true, default: '' },
        site: { key: 'site', converter: new (ClassConverterFactory.build(ManquementSiteEdition))(), optional: true },
        contenants: {
                          key: 'contenants',
                          converter: new (ArrayClassConverterFactory.build(ManquementContenantEdition))(),
                          optional: true
                        }
    };

    millesime: string;
    cahier: string;
    produit: string;
    produitOrigine: string;
    numeroLot: string;
    cepage: string;
    volume: string;
    type: string;
    logement: string;
    contenantList: string;
    date: string;
    dateRetiraison: string;
    typeConditionnement: string;
    degre: string;
    numeroDossier: string;
    commentaire: string;

    procedure: string;
    couleur: string;
    numeroEchantillon: number;
    site: ManquementSiteEdition;
    contenants: ManquementContenantEdition[];
}
